import List from "@material-ui/core/List";

import React, { useMemo, useState } from "react";
import { CheckoutCardContent, CheckoutCardSubHeader } from "./CheckoutCard";
import { Trans, useTranslation } from "react-i18next";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../components/Common/FormikTextField";
import { getYUPValidators } from "../../../components/yupvalidators";
import ListItemRadioButton from "../../../components/Common/ListItemRadioButton";
import { useCheckout } from "../../providers/CheckoutProvider";
import { useAuth } from "../../providers/AuthProvider";

export default ({ deliveryMethod }) => {
  const { deliveryOptionData } = useCheckout();

  console.log("Delivery option data", deliveryOptionData);

  const { user } = useAuth();
  const { t } = useTranslation();
  const { setDeliveryOption } = useCheckout();
  console.log("The user", user);

  return (
    <>
      <Formik
        initialValues={{
          name: deliveryOptionData?.contactInfo?.name || user.name,
          emailAddress:
            deliveryOptionData?.contactInfo?.emailAddress || user.emailAddress,
        }}
        validateOnMount={true}
        validationSchema={schema(t)}
        onSubmit={(values, { setSubmitting, setErrors }) => {
          const data = {
            contactInfo: { ...values },
          };
          console.log("DeliveryMethod", deliveryMethod);
          setDeliveryOption(deliveryMethod.deliveryOptions[0], data);
        }}
      >
        {({ submitForm, isValid, isSubmitting }) => {
          return (
            <Form>
              <CheckoutCardContent>
                <CheckoutCardSubHeader>
                  <Trans>Contact details</Trans>
                </CheckoutCardSubHeader>

                <Field
                  component={FormikTextField}
                  label={t("Your name")}
                  name="name"
                />

                <Field
                  component={FormikTextField}
                  label={t("Your email address")}
                  name="emailAddress"
                />

                <Box mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!isValid}
                    type="submit"
                  >
                    <Trans>Next step</Trans>
                  </Button>
                </Box>
              </CheckoutCardContent>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const schema = (t) => () => {
  const validators = getYUPValidators(t);
  return Yup.object().shape({
    name: validators.FULL_NAME.required(t("This is required!")),
    emailAddress: validators.EMAIL_ADDRESS.required(t("This is required!")),
  });
};
